module.exports = __webpack_public_path__ + "img/spain-lung-cancer-female.5ddd908d.png";